/**
 * @generated SignedSource<<13f50e297e516bde3621114b0199aed3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileSettingsCertificateSectionFragment$data = {
  readonly userCertificates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"CertificateCardFragment">;
      };
    }>;
  };
  readonly " $fragmentType": "ProfileSettingsCertificateSectionFragment";
};
export type ProfileSettingsCertificateSectionFragment$key = {
  readonly " $data"?: ProfileSettingsCertificateSectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileSettingsCertificateSectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileSettingsCertificateSectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserCertificateNodeConnection",
      "kind": "LinkedField",
      "name": "userCertificates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserCertificateNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserCertificate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CertificateCardFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OrganizationMembership",
  "abstractKey": null
};

(node as any).hash = "545c962b646989c2e3e3495741979714";

export default node;
